module.exports = __webpack_public_path__ + "img/flowGroupWhite.11c30bca.png";